import {
  CHeader,
  CHeaderNav,
  CHeaderNavItem,
  CToggler
} from "@coreui/react";
import { authContext } from "auth/auth.provider";
import GetListOfUsersToLoad from "components/getUserOptionsToLoad";
import { memo, useContext, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import "scss/layouts/_header.scss";
import commonApi from "services/apis/common.api";
import { toggleSidebar } from "store/sidebar/action";
import AppConsentedNotify from "./appConsentedNotify";
import { HeaderDropdown } from "./index";

const TheHeader = () => {
  const sidebarShow = useSelector((state) => state?.["sidebar"].showSidebar);
  const dispatch = useDispatch();
  const [isUserSelected, setIsUserSelected] = useState(false);
  const [selectedUser, setSelectedUser] = useState<any>(null);
  const { user: authUser } = useContext(authContext);

  const { control } = useForm();

  const toggleSidebarHandler = () => {
    const val = [true, "responsive"].includes(sidebarShow)
      ? false
      : "responsive";
    dispatch(toggleSidebar(val));
  };

  const toggleSidebarMobile = () => {
    const val = [false, "responsive"].includes(sidebarShow)
      ? true
      : "responsive";
    dispatch(toggleSidebar(val));
  };

  const getUserHandler = async () => {
    await commonApi
      .fetchUser()
      .catch((error: XMLHttpRequest) => {
        if (error.status === 401) {
          // handle unauthenticated
        }
      });
  };


  return (
    <CHeader className="d-flex justify-content-between flex-nowrap">
      <CToggler
        inHeader
        className="ml-md-3 d-lg-none"
        onClick={toggleSidebarMobile}
      />
      <CToggler
        inHeader
        className="ml-3 d-md-down-none"
        onClick={toggleSidebarHandler}
      />
      <div className="d-flex" style={{ gap: "4px" }}>
        <AppConsentedNotify />
      </div>
      <CHeaderNav>
        <CHeaderNavItem>
          <Controller
            name="user"
            control={control}
            defaultValue={null}
            render={({ field: { ref, ...rest } }) => (
              <GetListOfUsersToLoad
                {...rest}
                isClearable={true}
                control={control}
                value={selectedUser}
                defaultUserId={authUser.syncInitiatedUserID}
                onChange={(e) => {
                  rest.onChange(e);
                  setSelectedUser(e);
                  setIsUserSelected(!!e?.value);
                }}
              />
            )}
          />
        </CHeaderNavItem>

        <CHeaderNavItem>

        </CHeaderNavItem>

        <CHeaderNavItem>
          <HeaderDropdown />
        </CHeaderNavItem>
      </CHeaderNav>
    </CHeader>
  );
};

export default memo(TheHeader);
